module.exports = __webpack_public_path__ + "static/media/MK 14+text.8c64b4c7.mp3";